import React, { createContext, useContext, useState } from "react";
import { setThemeMode } from "../utils/themeColors";

type ThemeMode = "light" | "dark";

interface ThemeContextType {
  mode: ThemeMode;
  toggleMode: () => void;
  setMode: (mode: ThemeMode) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [mode, setMode] = useState<ThemeMode>("light");

  // Initialize theme on component mount
  /*  useEffect(() => {
    const currentMode = getThemeMode();
    setMode(currentMode);
    setThemeMode(currentMode === 'dark');
  }, []); */

  // Toggle between light and dark mode
  const toggleMode = () => {
    const newMode = mode === "light" ? "dark" : "light";
    setMode(newMode);
    setThemeMode(newMode === "dark");
  };

  // Set specific mode
  const handleSetMode = (newMode: ThemeMode) => {
    setMode(newMode);
    setThemeMode(newMode === "dark");
  };

  return (
    <ThemeContext.Provider value={{ mode, toggleMode, setMode: handleSetMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
